/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileTypeIn
 */
export interface FileTypeIn {
    /**
     * 
     * @type {string}
     * @memberof FileTypeIn
     */
    fileType: string;
}

export function FileTypeInFromJSON(json: any): FileTypeIn {
    return FileTypeInFromJSONTyped(json, false);
}

export function FileTypeInFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileTypeIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileType': json['fileType'],
    };
}

export function FileTypeInToJSON(value?: FileTypeIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileType': value.fileType,
    };
}


